import { render, staticRenderFns } from "./Caracteristica.vue?vue&type=template&id=348a1291"
import script from "./Caracteristica.vue?vue&type=script&lang=js"
export * from "./Caracteristica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports